module.exports = __webpack_public_path__ + "static/media/sponcer_DashHudson.6211f22b.svg";